import { render, staticRenderFns } from "./AddAssessmentAction.vue?vue&type=template&id=8e6917b0&"
import script from "./AddAssessmentAction.vue?vue&type=script&lang=js&"
export * from "./AddAssessmentAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports